import { render, staticRenderFns } from "./vendorLabel.vue?vue&type=template&id=5f4c3dc7&scoped=true"
import script from "./vendorLabel.vue?vue&type=script&lang=js"
export * from "./vendorLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4c3dc7",
  null
  
)

export default component.exports